var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.03293 9L19.9671 9C20.9872 9 21.3878 7.64858 20.539 7.07059L12.1438 1.35375C11.4512 0.882083 10.5488 0.882083 9.85618 1.35375L1.46102 7.07059C0.612236 7.64858 1.01282 9 2.03293 9Z",
    stroke: "#3C7795",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9H8V17H3V9Z",
    stroke: "#3C7795",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9H19V17H14V9Z",
    stroke: "#3C7795",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.382 17C18.7607 17 19.107 17.214 19.2764 17.5528L20.2764 19.5528C20.6088 20.2177 20.1253 21 19.382 21H2.61803C1.87465 21 1.39116 20.2177 1.72361 19.5528L2.72361 17.5528C2.893 17.214 3.23926 17 3.61803 17L18.382 17Z",
    stroke: "#3C7795",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.5d328d65fac5a93cb4e84474031a2c50.svg";
export { ForwardRef as ReactComponent };